var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { TableCell as MuiTableCell } from '@mui/material';
import { ChevronDown } from '../../assets/icons';
import colors from '../../themes/colors';
var StyledMuiCell = styled(MuiTableCell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 48px;\n  z-index: 3;\n  cursor: pointer;\n  user-select: none;\n  background-color: ", ";\n"], ["\n  width: 48px;\n  z-index: 3;\n  cursor: pointer;\n  user-select: none;\n  background-color: ", ";\n"])), function (_a) {
    var highlightOdds = _a.highlightOdds, index = _a.index;
    return highlightOdds && index % 2 === 0 ? colors.neutral0 : colors.white;
});
var StyledChevron = styled(ChevronDown)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform: rotate(", ");\n  transition: transform 0.1s ease;\n  fill: ", ";\n"], ["\n  transform: rotate(", ");\n  transition: transform 0.1s ease;\n  fill: ", ";\n"])), function (_a) {
    var open = _a.open;
    return (open ? '0' : '-90deg');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? colors.neutral60 : colors.neutral80);
});
export default function TableExpandableCell(props) {
    var _a;
    var index = props.index, disabled = props.disabled, onCollapseClick = props.onCollapseClick, _b = props.open, open = _b === void 0 ? false : _b, config = props.config, row = props.row;
    var onCellClick = function () {
        if (disabled)
            return;
        if (typeof index !== 'undefined')
            onCollapseClick(index);
    };
    var rowColor;
    var style = {
        width: 48,
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (row && index !== 'all') {
        rowColor = (_a = config === null || config === void 0 ? void 0 : config.rowColor) === null || _a === void 0 ? void 0 : _a.call(config, row, index);
        style.backgroundColor = "".concat(rowColor, " !important");
    }
    return (_jsx(StyledMuiCell, __assign({ sx: style, highlightOdds: index !== 'all', index: index !== 'all' ? index : 0, onClick: onCellClick }, { children: _jsx("div", __assign({ style: { display: 'flex', alignItems: 'center', height: '100%' } }, { children: _jsx(StyledChevron, { disabled: disabled, open: open }) })) })));
}
var templateObject_1, templateObject_2;
